import { LoadingOutlined } from "@ant-design/icons";
import { Col, Form, Modal, Row, Tree } from 'antd';
import React, { useEffect, useState } from 'react';
import liracrypt from '../components/Liracrypt/liracrypt';
import StAddNew from "./DSeries/StAddNew";
import ZenMultiLines from "../components/PhantomZen/ZenMultiLines";
import RoutePage from "../components/RoutePage";
import queryString from "query-string";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";

const TreeComponent = ({
    url,
    extraData,
    urlData
}) => {
    const [loading, setLoading] = useState(false);
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const urlCode = useSelector(state => state.urlCode);
    const [treeConfig, setTreeConfig] = useState();
    const [treeData, setTreeData] = useState();
    const [smodal, setSmodal] = useState();
    const [showModal, setShowModal] = useState(false);
    const [smodalTitle, setSmodalTitle] = useState("");
    const [smodalForm] = Form.useForm();
    const onSelect = (e, selectedKey) => {
        if (selectedKey.clickAction?.action === 'newTab') {
            window.open(`/v02/${urlCode}` + selectedKey.clickAction?.newTab?.route, '_blank');
        };
        if (selectedKey.clickAction?.action === 'smodal') {
            setSmodal(selectedKey.clickAction?.smodal);
            setShowModal(true);
        }
    };


    useEffect(() => {
        setLoading(true);
        liracrypt.get(url, urlData).then(({ data }) => {
            //let _treeData = [];
            // data.data.forEach(x => {
            //     x.style = {
            //         color: 'red',
            //         fontSize: 13
            //     }
            //     if (x.children) {
            //         x.children.forEach(y => {
            //             y.icon = <CarryOutOutlined />;
            //             y.style = {
            //                 color: 'red',
            //                 fontSize: 13
            //             }
            //             if (y.children) {
            //                 y.children.forEach(z => {
            //                     z.icon = <CarryOutOutlined />;
            //                     z.style = {
            //                         color: 'red',
            //                         fontSize: 13
            //                     }
            //                 })
            //             }
            //         });
            //     }
            //     _treeData.push(x);
            // });
            setTreeConfig(data.config);
            setTreeData(data.data);
            setLoading(false);
        }).catch(err => {
            console.log(err);
        })
    }, []);

    return (
        loading ? <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "80vh",
            }}
        >
            <LoadingOutlined
                style={{ fontSize: 80, color: "#007bff" }}
                spin
            />
        </div> :
            <>
                <Modal
                    onCancel={() => setShowModal(false)}
                    onOk={() => setShowModal(false)}
                    title={smodalTitle}
                    open={showModal}
                    cancelButtonProps={{ hidden: true }}
                    okButtonProps={{ hidden: true }}
                    width="60%"
                >
                    <StAddNew
                        setSmodalTitle={title => setSmodalTitle(title)}
                        form={smodalForm}
                        colSpan={24}
                        urlEndpoint={smodal?.urlEndpoint}
                        // dictName={smodal?.dictName}
                        urlData={{ dictName: smodal?.dictName }}
                        pageName={smodal?.pageName}
                    // urlData={{ dictName: props.aux[key]["dictName"] }}
                    />
                </Modal>
                <Row>
                    <Col span={24}>
                        {
                            (treeConfig?.zenFuncs?.headerRoute && treeConfig?.headerRoute?.route) ?
                                <Row>
                                    <Col span={24}>
                                        <div style={{ width: '500px', display: 'block', margin: 'auto' }}>
                                            <RoutePage route={treeConfig?.headerRoute?.route} params={{ ...searchParams, ...urlData || {}, ...treeConfig?.headerRoute?.params }} />
                                        </div>
                                    </Col>
                                </Row>
                                : <></>
                        }
                    </Col>
                </Row>
                <ZenMultiLines style={{ backgroundColor: treeConfig?.headerMultiline?.['background-color'] || 'transparent' }} classes="zen-multi-header" visible={treeConfig?.zenFuncs?.headerMultiline || false} singleLineColumns={treeConfig?.headerMultiline?.singleCol || []} multiLineColumns={treeConfig?.headerMultiline?.multiCol || []} />
                {
                    treeData && (
                        <div
                            style={{
                                boxShadow: "5px 5px 10px #1e1e1e,-5px -5px 10px #2e2e2e",
                                borderRadius: "10px",
                                padding: 15
                            }}
                        >
                            <Tree
                                className="dynamic-tree-component"
                                onClick={onSelect}
                                selectable={false}
                                showLine={true}
                                showIcon={false}
                                defaultExpandedKeys={null}
                                treeData={treeData}
                            />
                        </div>
                    )
                }
                <div style={{ marginTop: 10 }}>
                    <ZenMultiLines style={{ backgroundColor: treeConfig?.footerMultiline?.['background-color'] || 'transparent' }} classes="zen-multi-header" visible={treeConfig?.zenFuncs?.footerMultiline || false} singleLineColumns={treeConfig?.footerMultiline?.singleCol || []} multiLineColumns={treeConfig?.footerMultiline?.multiCol || []} />
                </div>
            </>
    )
};

export default TreeComponent;